'use es6';

import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// import Loadable from 'UIComponents/decorators/Loadable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import { getEmailCreditLimit, getEmailCreditUsed, getHasPortalReachedThreshold } from 'EmailData/selectors/portalSendCreditsSelectors';
import { getIsFreeEmail } from 'EmailData/selectors/user';
import { getIsProductReadOnly } from 'EmailData/selectors/portalCritsitSelectors';
import { showPortalProbationWarningSelector, showPortalSuspensionSelector } from 'EmailData/portalStatus/selectors';
import CreditLimitAlert from 'EmailComponents/CreditLimitAlert';
import { View } from 'foundations-components/transitional/components/View';

// ui-addon-upgrades is very large dep to always include
// const AsyncCreditLimitAlert = Loadable({
//   loader: () =>
//     import(
//       /* webpackChunkName: "ui-addon-upgrades" */ 'EmailComponents/CreditLimitAlert'
//     ),

//   LoadingComponent: () => null,
//   ErrorComponent: () => null,
// });
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  creditsUsed: getEmailCreditUsed(state),
  hasReachedWarningThreshold: getHasPortalReachedThreshold(state),
  isFree: getIsFreeEmail(state),
  isProductReadOnly: getIsProductReadOnly(state),
  isPortalSuspended: showPortalSuspensionSelector(state),
  isPortalSuspensionWarning: showPortalProbationWarningSelector(state),
  portalLimit: getEmailCreditLimit(state)
});
class BannerContainer extends Component {
  render() {
    const {
      creditsUsed,
      hasReachedWarningThreshold,
      isFree,
      isPortalSuspended,
      isPortalSuspensionWarning,
      isProductReadOnly,
      portalLimit,
      hideBannerForMc0653Experiment
    } = this.props;
    const banners = [];
    if (isProductReadOnly) {
      banners.push( /*#__PURE__*/_jsx(UIAlert, {
        closeable: false,
        titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "EmailComponents.productIsReadOnlyBanner.title"
        }),
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'EmailComponents.productIsReadOnlyBanner.manageDescription'
        })
      }, "statistics-disabled"));
    }
    if (isPortalSuspended || isPortalSuspensionWarning) {
      return banners;
    } else if (hasReachedWarningThreshold && !hideBannerForMc0653Experiment) {
      banners.push( /*#__PURE__*/_jsx(CreditLimitAlert, {
        creditsUsed: creditsUsed,
        hasReachedThreshold: hasReachedWarningThreshold,
        hasUnpaidExperience: isFree,
        portalLimit: portalLimit
      }, "creditLimitAlert"));
    }
    if (banners.length === 0) {
      return banners;
    }
    return /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "200",
      as: "div",
      children: banners
    });
  }
}
BannerContainer.propTypes = {
  creditsUsed: PropTypes.number,
  hasReachedWarningThreshold: PropTypes.bool,
  isFree: PropTypes.bool,
  isPortalSuspended: PropTypes.bool.isRequired,
  isPortalSuspensionWarning: PropTypes.bool.isRequired,
  isProductReadOnly: PropTypes.bool,
  portalLimit: PropTypes.number,
  hideBannerForMc0653Experiment: PropTypes.bool
};
export default connect(mapStateToProps)(BannerContainer);